<template>
  <div>
    <!-- 版本小于7.3 -->
    <Stance
      v-if="showApp"
      type="general"
      :btn-text="appTxt"
      :show-info="false"
      :descText="appMsg"
      @click="btnClick"
      :show-btn="showAppBtn"
    />
    <!-- 已认证 -->
    <div class="commit-info" v-if="!showApp && +status === 1">
      <img class="result-img" :src="$setPicSize(successImg)" />
      <div class="result-info">
        <header>您已完成商家实人认证</header>
        <div class="desc">
          <span class="desc-info">{{ userName }}</span
          ><span>{{ cardID }}</span>
        </div>
      </div>
    </div>

    <!-- 审核中 -->
    <div class="commit-info" v-if="!showApp && +status === 4">
      <img class="result-img" :src="$setPicSize(failImg)" />
      <div class="result-info">
        <header>审核中</header>
        <div class="desc">商家实人认证审核中，请耐心等待</div>
      </div>
    </div>

    <!-- 未验证/验证失败 扫脸失败 -->
    <div class="commit-info" v-if="!showApp && +status != 1 && +status != 4">
      <div class="form">
        <!-- 扫脸失败无需拍照片 -->
        <section class="upload-area" v-if="+status != 5">
          <media-upload-item class="id-card front" type="front" @uploaded="frontPicUploaded">
            <div class="sample-cover"></div>
          </media-upload-item>
          <media-upload-item class="id-card back" type="back" @uploaded="backPicUploaded">
            <div class="sample-cover"></div>
          </media-upload-item>
          <div style="clear: both; width: 100%;"></div>
        </section>

        <section class="basic-info">
          <div class="item">
            <input
              class="user-name"
              type="text"
              :disabled="disabled"
              v-model="userName"
              placeholder="请输入真实姓名"
              maxlength="15"
            />
          </div>
          <div class="item">
            <input
              class="user-card-id"
              type="text"
              :disabled="disabled"
              v-model="cardID"
              placeholder="请输入证件号码"
              maxlength="18"
            />
          </div>
        </section>

        <section class="guide-info">
          <div class="main">{{ guideTitle }}</div>
          <div class="detail">{{ guideDetail }}</div>
        </section>
      </div>

      <z-button-group>
        <z-button type="primary" :text="btnText" :disabled="!canSubmit" @click="submit"></z-button>
      </z-button-group>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
import { lego } from '@zz-common/lego'
import { Stance, Dialog, Button, ButtonGroup } from '@zz-common/zz-ui'
import {
  getbizcertificationstatus,
  idcardpicallcheck,
  needfaceauth
} from '@api/resourceApi'
import { getMaskData } from '@zz-common/zz-utils'
import { compatibleHarmony } from '@/lib/utils'
import { toast } from '../../native'
import {
  queryParams,
  isCheckApp,
  isHunterApp,
  getCookie,
  getDownAppUrl,
  compareVersion
} from '../../lib/utils'

//  TODO
import MediaUploadItem from './MediaUploadItem/MediaUploadItem'
// import BottomButton from './BottomButton/BottomButton'

//status "1已认证2未认证3认证过期4审核中5仅人脸失败"
const query = queryParams()

export default {
  name: 'CommitInfo',
  data() {
    return {
      sourceCode: query.sourceCode || this.$route.query.sourceCode,
      authtype: query.authtype || this.$route.query.authtype,
      uid: query.uid || this.$route.query.uid || '',
      guideTitle: '注意事项',
      guideDetails: {
        3: '1. 请拍摄上传店铺经营者身份证正反面照片，确保身份证照片清晰、无遮挡，身份证在有效期内；\n2. 该认证资料验证通过后无法更改，请确认信息真实有效。',
        2: '1. 请拍摄上传店铺经营者本人身份证正反面照片，确保身份证照片清晰、无遮挡，身份证在有效期内；\n2. 请填写店铺经营者本人身份证姓名与身份证号 ；\n3. 该认证资料验证通过后无法更改，请确认信息真实有效。若您在平台未进行过实人认证，身份证信息校验通过后，需要您进行扫脸认证。',
        5: '1.点击提交验证后，请本人对准屏幕框进行扫脸认证。\n2.该认证资料验证通过后无法更改，请确认信息真实有效。'
      },
      userName: '',
      cardID: '',
      nameReal: '',
      idCardReal: '',
      status: '',
      idCardFrontPicRst: '',
      idCardBackPicRst: '',
      isCheckApp,
      isHunterApp,
      btnText: '开始认证',
      showApp: false,
      showAppBtn: true,
      appTxt: '',
      appMsg: '',
      myUid: '',
      successImg: 'f9436be4-ddfb-4f7b-8047-f0ae914e714c.png',
      failImg: '2980c180-8a0e-48e5-9ffb-ec7ad3ec4766.png'
    }
  },
  watch: {
    myUid(curvalue, newval) {
      console.log('curvalue', curvalue)
      console.log('newval', newval)
      if (this.uid !== '' && curvalue !== '' && this.uid !== curvalue) {
        Dialog.alert({
          message: '您扫码要认证的账号，与当前手机设备登录账号存在不一致，请仔细确认。'
        }).then(() => {})
      }
      this.init()
      this.fetchState()
    }
  },
  computed: {
    disabled() {
      return +this.status === 3 || +this.status === 5
    },
    canSubmit() {
      if (+this.status === 5) return this.userName && this.cardID
      return this.userName && this.cardID && this.idCardFrontPicRst && this.idCardBackPicRst
    },
    guideDetail() {
      return this.guideDetails[+this.status]
    }
  },
  methods: {
    init() {
      const appV = native.client
      if (appV === 'zz') {
        if (!compareVersion(getCookie('v') || '', '7.3.0')) {
          this.showApp = true
          this.appTxt = '下载最新版本'
          this.appMsg = '请升级最新APP版本后进行商业认证'
          this.showAppBtn = true //下方按钮功能不是关闭页面而是下载app
          lego.send({
            pagetype: 'ZZUP_BUSREALAUTH_COMMITINFO',
            actiontype: 'PAGE_SHOW_ZZUP',
            backup: {
              sourceCode: this.sourceCode,
              status: '9999'
            }
          })
          return ''
        }
        this.showApp = false
        return ''
      }
      if (isHunterApp) {
        if (!compareVersion(getCookie('hv') || '', '1.2.3')) {
          this.showApp = true
          this.appTxt = ''
          this.appMsg = '请升级最新APP版本后进行商业认证'
          this.showAppBtn = false //下方按钮功能不是关闭页面而是下载app
          return ''
        }
        this.showApp = false
        return ''
      }
      this.showApp = true
      this.appMsg = '请打开APP后进行商业认证'
      this.showAppBtn = false
    },
    fetchState() {
      getbizcertificationstatus({
        sourceCode: this.sourceCode
      })
        .then((res) => {
          console.log(res)
          if (this.authtype === 'reverify' && +res.status === 2) {
            this.userName = localStorage.getItem('userName') || ''
            this.cardID = localStorage.getItem('userCardNo') || ''
            console.log('localStorage', localStorage.getItem('userName'))
            // localStorage.removeItem('userName');
            // localStorage.removeItem('userCardNo');
          }
          if (res.name) this.userName = res.name
          if (res.idCard) this.cardID = res.idCard
          this.nameReal = res.nameReal
          this.idCardReal = res.idCardReal
          this.status = res.status
          lego.send({
            pagetype: 'ZZUP_BUSREALAUTH_COMMITINFO',
            actiontype: 'PAGE_SHOW_DETIAL',
            backup: {
              sourceCode: this.sourceCode,
              status: res.status
            }
          })
        })
        .catch((err) => {
          console.error(err)
          this.legoError(err.message)
          // toast({
          //   msg: err.message || '获取失败',
          //   style: '2'
          // })
        })
    },
    btnClick() {
      const url = getDownAppUrl()
      if (!url) return toast({ msg: '当前设备不支持下载', style: '2' })
      window.location.href = url
    },
    isUserNameValid() {
      const regName = /^[\u2e80-\u9fff]+(·[\u2e80-\u9fff]+)*$/
      return regName.test(this.userName)
    },
    isIDCardValid() {
      const regIdNo = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      return regIdNo.test(this.cardID)
    },
    frontPicUploaded(rst, _startTime) {
      this.idCardFrontPicRst = rst
    },
    backPicUploaded(rst, _startTime) {
      this.idCardBackPicRst = rst
    },
    legoError(reason) {
      lego.send({
        pagetype: 'ZZUP_BUSREALAUTH_COMMITINFO',
        actiontype: 'ERROR',
        backup: {
          sourceCode: this.sourceCode,
          reason
        }
      })
    },
    skipSuccess(code = 2) {
      native.skipToUrl({
        targetUrl: `https://feentry.zhuanzhuan.com/auth_face?clientid=BusinessRealAuthCommitResult&pageFrom=${code}&from=${this.sourceCode}`,
        needClose: '1'
      })
    },
    isNeedfaceauth() {
      needfaceauth({
        sourceCode: this.sourceCode,
        name: this.userName,
        idCard: this.cardID
      })
        .then((res) => {
          if (+res.result === 0) return this.skipSuccess(2)
          if (+res.result === 1) {
            //需要扫脸
            console.log('需要扫脸')
            if (compatibleHarmony()) return;
            native.wrap('startFaceVerify')(
              {
                sourceCode: this.sourceCode,
                name: +this.status === 5 ? this.nameReal : this.userName,
                cardId: +this.status === 5 ? this.idCardReal : this.cardID
              },
              (res) => {
                console.log('扫脸返回数据')
                console.log(res)
                if (res.result === '1' || res.result === '0') {
                  //扫脸失败/成功 跳到结果页
                  return native.skipToUrl({
                    targetUrl: res.jumpUrl,
                    needClose: '1'
                  })
                } else if (res.errorMsg) {
                  //兼容IOS开始吊起扫脸会返回结果
                  toast({
                    msg: res.errorMsg || '扫脸失败',
                    style: '2'
                  })
                }
              }
            )
          }
        })
        .catch((err) => {
          console.error(err)
          this.legoError(err.message)
          // toast({
          //   msg: err.message || '提交失败',
          //   style: '2'
          // })
        })
    },
    submit() {
      if (+this.status !== 5) this.canSubmitInfo()
      if (!this.canSubmit) return ''
      console.info(`姓名：${this.userName}`)
      console.info(`身份证：${this.cardID}`)
      console.info(`sourceCode${this.sourceCode}`)
      console.info(`照片地址码：\n正\t${this.idCardFrontPicRst}\n反\t${this.idCardBackPicRst}`)
      lego.send({
        pagetype: 'ZZUP_BUSREALAUTH_COMMITINFO',
        actiontype: 'CLICK',
        backup: {
          sourceCode: this.sourceCode,
          status: this.status
        }
      })
      if (+this.status === 5) return this.isNeedfaceauth() //5 无需校验照片 直接判断扫脸
      idcardpicallcheck({
        sourceCode: this.sourceCode,
        name: this.userName,
        idCard: this.cardID,
        pic: `${this.idCardFrontPicRst}|${this.idCardBackPicRst}`
      })
        .then((res) => {
          const maskData = getMaskData({
            A01_13: this.userName,
            C01_09: this.cardID,
            C02_03: ''
          })
          lego.send({
            pagetype: 'privacy',
            actiontype: 'information',
            backup: {
              value: JSON.stringify(maskData || {})
            }
          })
          //  成功
          if (res.isPass === 'true') {
            if (+this.status === 3) return this.skipSuccess(4) //过期状态无需扫脸 直接跳到成功页
            if (+this.status === 2) {
              this.isNeedfaceauth() //验证是否需要扫脸
            }
          } else {
            toast({
              msg: res.message || '提交失败',
              style: '2'
            })
            // this.isNeedfaceauth();//验证是否需要扫脸
          }
        })
        .catch((err) => {
          // this.isNeedfaceauth();//验证是否需要扫脸
          //  失败
          console.error(err)
          this.legoError(err.message)
          // toast({
          //   msg: err.message || '提交失败',
          //   style: '2'
          // })
        })
    },
    canSubmitInfo() {
      if (!this.disabled && !this.isUserNameValid()) {
        toast({
          msg: '姓名错误，请填写中文',
          style: '2'
        })
        return
      }
      if (!this.disabled && !this.isIDCardValid()) {
        toast({
          msg: '身份证号格式错误，请重新填写',
          style: '2'
        })
        return
      }
      if (!this.idCardFrontPicRst || !this.idCardBackPicRst) {
        toast({
          msg: '请上传身份证后再认证',
          style: '2'
        })
      }
    },
    $setPicSize(url) {
      return setPicSize(url, 500, 500)
    }
  },
  mounted() {
    native.setTitle({
      title: '商业实人认证'
    })
    lego.send({
      pagetype: 'ZZUP_BUSREALAUTH_COMMITINFO',
      actiontype: 'PAGE_SHOW',
      backup: {
        sourceCode: this.sourceCode
      }
    })
    this.init()
    // this.fetchState();
    //获取用户uid 判断登陆状态
    native.wrap('getUserId')((res) => {
      console.log('res', res)
      if (res.code === '0') {
        this.myUid = res.uid
        console.log('this.myUid', this.myUid)
      } else {
        Dialog.alert({
          message: '检测到您没有登陆账户，请登陆后继续认证'
        }).then(() => {
          native.wrap('login')((res) => {
            if (res.code === '0') {
              this.myUid = getCookie('uid')
            } else {
              Dialog.alert({
                message: '登陆失败'
              }).then(() => {
                native.close()
              })
            }
          })
        })
      }
    })
    native.wrap('setKeyboardFrameChangeCallback')((res) => {
      if (!res.kbState) return
      if (res.kbState === '1') {
        document.querySelector('.commit-info > footer').style.display = 'none'
      } else {
        document.querySelector('.commit-info > footer').style.display = 'block'
      }
    })
  },
  components: {
    MediaUploadItem,
    Stance,
    zButtonGroup: ButtonGroup,
    zButton: Button
  }
}
</script>

<style lang="less" scoped>
  @import 'CommitInfo.less';
</style>
